import { useState, useEffect } from 'react';

interface VisualViewportInfo {
  width: number;
  height: number;
}

const useVisualViewport = (): VisualViewportInfo => {
  const [viewportInfo, setViewportInfo] = useState<VisualViewportInfo>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const updateViewportInfo = () => {
      setViewportInfo({
        width: window.innerWidth || 0,
        height: window.innerHeight || 0,
      });
    };

    // Check if window is defined (client-side)
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', updateViewportInfo);
      updateViewportInfo(); // Initial call to set the initial viewport info

      return () => {
        window.removeEventListener('resize', updateViewportInfo);
      };
    }
  }, []);

  return viewportInfo;
};

export default useVisualViewport;
